/*
 * @Author: KellyYang
 * @Date: 2022-06-28 10:09:17
 * @LastEditors: KellyYang
 * @Description: 产品服务
 */
import React, { Fragment } from "react";
import ProductListCom from '../Home/component/ProductList';
import product1 from "@/assets/img/home-page/product1.png";
import product2 from "@/assets/img/product-page/service1.png";
import product3 from "@/assets/img/product-page/service2.png";
import product4 from "@/assets/img/product-page/service3.png";
import product5 from "@/assets/img/product-page/service4.png";
import banner from "@/assets/img/product-page/product-banner.png";
import h5Banner from "@/assets/img/product-page/h5-product-banner.png";
import { isMobile } from '@/utils/utils';
import './index.less';

const Product = () => {
  const productData = [
    { img: product1, title: '智能小工具', content: '基于中小银行的科技基础能力，结合自身数字产业金融实践，锦誉征信独创的面向银行客户经理的智能移动尽调平台，助力银行开展数字普惠金融业务，服务下沉客群，内置PBOC模型、资金流水分析、负债分析和三方数据解析等标准模块，大幅增强机构或使用者的数字化风控能力和展业效率' },
    { img: product2, title: '微链数字普惠金融服务',  content: '以海南自贸港省市重点建设项目和新基建项目为核心，以审批通过的建设项目名单为基础，行方为项目名单中的相关服务方，如工程建设、材料供应等小微企业提供多种灵活的金融产品，打造海南省内基建行业的微链普惠金融，产品包括合同贷、商票贷、农民工工资保证金保函等' },
    { img: product3, title: '到货保理小工具', content: '通过订单发货、在途监管、到库签收等数据验证，形成贸易闭环，确立买卖双方应收应付的权利及义务，真实应收账款产生，以此为应收账款的转让提供辅助确权' },
    { img: product4, title: '企业大数据征信报告', content: '以全维度外部数据资源和内部数据沉淀为原料，通过深度数据挖掘构建风险标签体系，以关联风险传导模型识别企业隐藏的风险结构，形成全面风险画像，生成大数据征信报告' },
    { img: product5, title: '数据管理解决方案', content: '多维度数据产品，客观、全面地反映企业基本面和经营情况等信息，支持一站式接入，满足客户多元化数据需求。丰富的场景金融应用能力，可依据客户需求提供定制化产品和服务' },
  ]
  return (
    <Fragment>
      <div className="product-page">
        <section>
          <div className="product-page-header" style={{ backgroundImage: `url(${isMobile() ? h5Banner : banner})` }}>
            <div className="header-box">
              <div className="banner-title">
                <span>
                  以数据、征信、科技为核心
                </span>
              </div>
              <div className="banner-subtitle">
                <span>
                  助力普惠金融的合规健康发展
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="product-warp">
          <ProductListCom productData={productData} padding="80px 0" />
        </section>
      </div>
    </Fragment>
  )
}

export default Product;
